import React from 'react'

export default function Separator({ height = 24, width, maxHeight, minHeight }) {
  return <div style={{ height, width, maxHeight, minHeight }} aria-hidden />
}
